import {CampaignControllerName} from "../utils/names/controllerNames";
import {CampaignsController} from "./route/campaigns.controller";
import CampaignsModuleConfiguration from "./CampaignsModuleConfiguration";

CampaignsModuleConfiguration.createNewModule()
    .controller(CampaignControllerName, CampaignsController.instance);
